export default __webpack_public_path__ + "static/media/The Storm Harbor.a2bc1b6d.jpg";